"use client";
import React__default from 'react';
import { Typography, Button } from '@sravni/react-design-system';
import { useAnalytics } from '@sravni/react-utils/lib/hooks';

const AppStore = React__default.forwardRef((props, ref) => {
    const { store, useIcon, ...rest } = props;
    const { pushEvent } = useAnalytics();
    const handleClick = React__default.useCallback((event) => {
        const { store: appStore } = event.currentTarget.dataset;
        pushEvent({
            event: 'mainEvent',
            eventCategory: 'Футер',
            eventAction: 'Переход к установке приложения',
            eventLabel: `Футер|${appStore}`,
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (React__default.createElement(Typography.Link, { ...rest, ref: ref, key: store.name, href: store.href, onClick: handleClick, target: "_blank", rel: "nofollow noopener", "data-store": store.name }, 
    // eslint-disable-next-line no-nested-ternary
    useIcon
        ? React__default.createElement("img", { src: store.icon })
        : (React__default.createElement(Button, { size: 36, variant: "primary", "aria-label": store.name }, "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C"))));
});

export { AppStore };
//# sourceMappingURL=AppStore.js.map
